import { GridModel } from "common/models/utility-models/list-utility.model";
import { StudentsModel } from "../formmodel/student-data.model";

export class StudentsGridModel extends StudentsModel {
}

export class StudentsListingModel extends GridModel<StudentsGridModel> { }